import { useRef } from "react";
import { useReactToPrint } from "react-to-print";

interface UsePrintParams {
  documentTitle: string;
}

export const usePrint = ({ documentTitle }: UsePrintParams) => {
  const contentRef = useRef<HTMLDivElement>(null);

  const print = useReactToPrint({
    contentRef,
    documentTitle,
  });

  return { contentRef, print };
};
